import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-header navbar navbar-expand navbar-white navbar-light" }
const _hoisted_2 = { class: "navbar-nav" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "nav-item d-none d-sm-inline-block" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Inicio")
const _hoisted_8 = { class: "navbar-nav ml-auto" }

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_user_dropdown = _resolveComponent("user-dropdown")

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("button", {
          class: "nav-link",
          role: "button",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onToggleMenuSidebar && _ctx.onToggleMenuSidebar(...args)))
        }, _hoisted_5)
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "nav-link"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_8, [
      _createVNode(_component_user_dropdown)
    ])
  ]))
}